import { render } from "./Reports.vue?vue&type=template&id=0aa04a5c"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=0aa04a5c&lang=scss"

import exportComponent from "/home/nboq9356/fdes-meiser.ailoop.io/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__